import React from "react";
import QuoteRequestMini from "./quote-request-mini";

const QuoteRequestMiniStateContainer = (props) => {
  return <QuoteRequestMini {...props} />;
};

export default QuoteRequestMiniStateContainer;
